import { Config } from '@/reusable/types'
import yaml from 'js-yaml'

function interpolateUrlVariables (url: string): string {
  const variables: { [variableName: string]: string } = {
    THIS_LOCATION: window.location.protocol + '//' + window.location.host,
    THIS_HOST: window.location.hostname,
    THIS_PORT: window.location.port,
    THIS_PROTOCOL: window.location.protocol,
    THIS_WS_PROTOCOL: window.location.protocol === 'http:' ? 'ws' : 'wss',
  }
  for (const key in variables) {
    url = url.replace('{' + key + '}', variables[key])
  }
  return url
}

function replaceConfigUrls (config: Config): Config {
  return {
    company: {
      ...config.company,
      website: interpolateUrlVariables(config.company.website)
    },
    loadGlobalMessagesForLocales: config.loadGlobalMessagesForLocales,
    products: config.products.map((product) => {
      return {
        ...product,
        links: product.links.map((link) => {
          return {
            ...link,
            url: interpolateUrlVariables(link.url)
          }
        })
      }
    })
  }
}

/** App config variable is loaded via loadConfig right before initializing Vue in @/main.ts */
export let config: Config

export function loadConfig (): Promise<void> {
  return fetch('./config.yml')
    .then((response) => response.text())
    .then((response) => {
      const parsedConfig = yaml.safeLoad(response) as Config
      config = replaceConfigUrls(parsedConfig)
    })
}